import { SWReactIcons } from "@similarweb/icons";
import { colorsPalettes } from "@similarweb/styles";
import { Button, EmptyState } from "@similarweb/ui-components";
import { Flex } from "@similarweb/ui-components/foundations";

import { translate } from "app/filters/i18nFilter";

export const AIAgentMainErrorView = ({ resetErrorBoundary }: { resetErrorBoundary: () => void }) => {
    const renderCtaButton = () => {
        return <Button onClick={resetErrorBoundary}>{translate("si.common.refresh")}</Button>;
    };

    const renderImage = () => <SWReactIcons iconName="empty-state-browser" />;

    return (
        <Flex
            height="100%"
            justifyContent="center"
            boxShadow="0px 3px 6px 0px #0E1E3E14"
            background={colorsPalettes.carbon[0]}
            borderRadius="6px"
        >
            <EmptyState
                title={translate("common.error")}
                SvgImage={renderImage}
                CtaButtons={renderCtaButton}
                subtitle={translate("si.common.error.reload")}
            />
        </Flex>
    );
};
